/* unplugin-vue-components disabled */import script from "./clientProjectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./clientProjectDialog.vue?vue&type=script&setup=true&lang=js"

import "./clientProjectDialog.vue?vue&type=style&index=0&id=3c9e4436&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9e4436"]])

export default __exports__